import React from 'react';
import './Ndpr.css';
import ndprImage from '../assets/images/ndpr.png';

const Ndpr = () => {
  return (
    <div className="ndpr-section">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h2>NDPR Compliance</h2>
            <p>
              At Thrive Insurance Brokers Limited, we prioritize your privacy and data protection under the Nigeria Data Protection Regulation (NDPR). Our commitment includes:
            </p>
            <ul>
              <li>Implementing robust security measures for all personal data</li>
              <li>Ensuring transparent data processing practices</li>
              <li>Maintaining compliance with the highest privacy standards</li>
            </ul>
          </div>
          <div className="col-md-6">
            <img src={ndprImage} alt="NDPR" className="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ndpr;